import React from 'react';
import { useI18n } from '../context/I18nContext';
import { MessageCircle, Send, ArrowRight } from 'lucide-react';

export default function CommunityCTA() {
  const { meta, tr } = useI18n();
  const settings = meta?.settings || {};
  const siteMeta = {
    whatsapp: settings.social_whatsapp || 'https://api.whatsapp.com/send/?phone=905374630644',
    discord: settings.social_discord || 'https://discord.gg/h9xnRChVY8',
  };
  return (
    <section className="relative py-20 lg:py-28 bg-[#0a0a0e]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 gap-6">
          <div className="relative rounded-3xl overflow-hidden border border-emerald-500/30 bg-gradient-to-br from-emerald-950/50 via-[#0a0a0e] to-[#0a0a0e] p-10 card-hover">
            <div className="absolute -top-20 -right-16 w-72 h-72 rounded-full bg-emerald-500/15 blur-3xl" />
            <div className="relative">
              <div className="w-14 h-14 rounded-2xl bg-emerald-500/15 border border-emerald-500/40 flex items-center justify-center mb-6">
                <MessageCircle className="w-6 h-6 text-emerald-400" strokeWidth={2} />
              </div>
              <h3 className="font-display text-3xl md:text-4xl font-black text-white mb-3">{tr('community.wa_title', 'WhatsApp Kanalımıza Katılın')}</h3>
              <p className="text-white/60 mb-8 leading-relaxed max-w-md">{tr('community.wa_desc', 'En yeni güncellemelerden, sürpriz indirimlerden ve kampanyalardan ilk siz haberdar olun.')}</p>
              <a href={siteMeta.whatsapp} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-emerald-500 hover:bg-emerald-400 text-black font-extrabold tracking-widest text-xs transition">
                {tr('community.wa_btn', 'HEMEN KATIL')} <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="relative rounded-3xl overflow-hidden border border-indigo-500/30 bg-gradient-to-br from-indigo-950/50 via-[#0a0a0e] to-[#0a0a0e] p-10 card-hover">
            <div className="absolute -top-20 -right-16 w-72 h-72 rounded-full bg-indigo-500/15 blur-3xl" />
            <div className="relative">
              <div className="w-14 h-14 rounded-2xl bg-indigo-500/15 border border-indigo-500/40 flex items-center justify-center mb-6">
                <Send className="w-6 h-6 text-indigo-300" strokeWidth={2} />
              </div>
              <h3 className="font-display text-3xl md:text-4xl font-black text-white mb-3">{tr('community.dc_title', 'Discord Sunucumuza Katılın')}</h3>
              <p className="text-white/60 mb-8 leading-relaxed max-w-md">{tr('community.dc_desc', 'Geliştirici topluluğumuzla tanışın, destek alın ve üretkenlik paylaşın.')}</p>
              <a href={siteMeta.discord || 'https://discord.gg/h9xnRChVY8'} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-indigo-500 hover:bg-indigo-400 text-white font-extrabold tracking-widest text-xs transition">
                {tr('community.dc_btn', "DISCORD'A GİT")} <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
